var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$style.banner, _vm.$style[_vm.bannerType]] }, [
    _c(
      "div",
      { class: _vm.$style.bannerInnerContent },
      [
        _vm.bannerText
          ? _c("warningIcon", { class: _vm.$style.icon })
          : _vm._e(),
        _vm._v(" "),
        _c("p", { class: _vm.$style.bannerText }, [
          _vm._v("\n      " + _vm._s(_vm.bannerText) + "\n      "),
          _vm.learnMoreLink
            ? _c(
                "a",
                {
                  class: _vm.$style.learnMoreLink,
                  attrs: {
                    href: _vm.learnMoreLink,
                    target: "_blank",
                    rel: "noopener noreferrer",
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.learnMoreText) + "\n        "
                  ),
                  _c("externalLinkIcon", {
                    class: _vm.$style.externalLinkIcon,
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }